import React from 'react';
import { CheckIcon, LockIcon, MonitorSmartphoneIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { GoldSeal } from '../GoldSeal';
import { LazyImage } from '../LazyImage';
import { bonuses } from '../../data/landing';
import { CHECKOUT_URL, DISCOUNT_LABEL, MOCKUP_URL, ORIGINAL_PRICE, PRICE } from '../../data/offer';
const includes = [{
  strong: '7 módulos',
  text: 'organizados por temática'
}, {
  strong: '+60 sesiones listas',
  text: 'con objetivos y estructura'
}, {
  strong: 'Fichas, preguntas guía y ejercicios',
  text: 'para adaptar'
}, {
  strong: '5 bonos de regalo',
  text: 'solo hoy con tu compra',
  highlight: true
}];
const trust = [{
  label: 'Garantía de 7 días',
  icon: ShieldCheckIcon
}, {
  label: 'Pago seguro',
  icon: LockIcon
}, {
  label: 'Acceso inmediato',
  icon: ZapIcon
}, {
  label: 'Cualquier dispositivo',
  icon: MonitorSmartphoneIcon
}];
export function PricingSection() {
  return <section id="comprar" className="scroll-mt-4 bg-petrol-900 py-12 sm:py-20" data-id="element-250" data-mp="a32w6aegfjli">
      <div className="mx-auto max-w-5xl px-4 sm:px-8" data-id="element-251" data-mp="f3qp51m8uaid">
        <div className="mb-6 text-center sm:mb-10" data-id="element-252" data-mp="f14euu7yxgwg">
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-gold-400" data-id="element-253" data-mp="6q7jqxrnvxm">Tu biblioteca profesional</p>
          <h2 className="mt-2 font-serif text-[2rem] leading-tight text-cream sm:text-5xl" data-id="element-254" data-mp="55t0id0h2bp8">
            Empezá hoy con <span className="italic text-gold-300" data-id="element-255" data-mp="sv43m15aoi6j">todo listo</span>
          </h2>
        </div>

        <div className="overflow-hidden rounded-[28px] bg-paper shadow-[0_40px_80px_-40px_rgba(0,0,0,0.8)] ring-1 ring-gold-400/60" data-id="element-256" data-mp="xt5nupeginjl">
          {/* Countdown */}
          <div className="flex flex-col items-center gap-2.5 border-b border-gold-400/40 bg-petrol-800 px-4 py-4 sm:flex-row sm:justify-center sm:gap-6 sm:py-5" data-id="element-257" data-mp="o3dntfnl927q">
            <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-gold-300" data-id="element-258" data-mp="1brdigqo0tcrl">
              Tu oferta termina en:
            </p>
            <Countdown data-id="element-259" data-mp="1qf41lldctkrb" />
          </div>

          <div className="grid lg:grid-cols-[1fr_1.05fr]" data-id="element-260" data-mp="1qe2lv3le8a39">
            {/* Producto */}
            <div className="relative flex flex-col items-center bg-beige-100 px-5 pb-6 pt-6 sm:px-8 sm:pt-8" data-id="element-261" data-mp="1lhvjtlw4biql">
              <div className="relative w-full max-w-[260px] sm:max-w-[360px]" data-id="element-262" data-mp="1hhbkcbo2o31a">
                <LazyImage src={MOCKUP_URL} width={1254} height={1254} alt="Kit Sexualidad Práctica con sus 7 módulos y 5 bonos" className="w-full mix-blend-multiply" data-id="element-263" data-mp="1cg4bsae3uztk" />
                <div className="absolute -right-2 -top-2 sm:-right-6" data-id="element-264" data-mp="xsj92hl572m6">
                  <GoldSeal size={84} data-id="element-265" data-mp="tqfwtqqnftzu" />
                </div>
              </div>

              <div className="mt-4 w-full" data-id="element-266" data-mp="oqtitf2zy9pz">
                <p className="text-center text-[10px] font-bold uppercase tracking-[0.18em] text-terra-600" data-id="element-267" data-mp="opryek03cavl">
                  + 5 bonos de regalo incluidos
                </p>
                <ul className="mt-3 grid grid-cols-5 gap-1.5 sm:gap-2" data-id="element-268" data-mp="2vflgpl3ml9ks">
                  {bonuses.map(b => <li key={b.number} className="aspect-square overflow-hidden rounded-lg bg-paper p-1 ring-1 ring-beige-200" data-id="element-269" data-mp="30d3sdj9122wh">
                      <LazyImage src={b.image} width={b.imageWidth} height={b.imageHeight} alt={`Bono ${b.number}: ${b.title}`} className="h-full w-full object-contain mix-blend-multiply" data-id="element-270" data-mp="35e17fmyqqgtr" />
                    </li>)}
                </ul>
              </div>
            </div>

            {/* Oferta */}
            <div className="flex flex-col px-5 py-7 sm:px-10 sm:py-10" data-id="element-271" data-mp="2qg8tv0cr82i7">
              <h3 className="text-center font-serif text-3xl leading-tight text-petrol-800 sm:text-4xl lg:text-left" data-id="element-272" data-mp="1ty2sx3ksn2l5">
                Kit Sexualidad Práctica
              </h3>

              <ul className="mt-5 space-y-2.5" data-id="element-273" data-mp="1xxld1x4sj9mx">
                {includes.map(item => <li key={item.strong} className="flex items-start gap-3" data-id="element-274" data-mp="1esypjyianmrv">
                    <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${item.highlight ? 'bg-gold-400 text-petrol-900' : 'bg-petrol-800 text-cream'}`} data-id="element-275" data-mp="19xb3hrz3z9ql">
                      <CheckIcon className="h-3 w-3" strokeWidth={3.5} aria-hidden="true" data-id="element-276" data-mp="1xkj4vytf1ync" />
                    </span>
                    <p className="text-[15px] leading-snug text-ink/75" data-id="element-277" data-mp="1sly3vx6cbaxu">
                      <strong className={item.highlight ? 'text-terra-600' : 'text-petrol-800'} data-id="element-278" data-mp="27k0bcighsgkd">{item.strong}</strong>{' '}
                      {item.text}
                    </p>
                  </li>)}
              </ul>

              <div className="relative mt-8 rounded-2xl bg-petrol-800 px-5 pb-5 pt-7 text-center" data-id="element-279" data-mp="d5zajs1dtjhn">
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-terra-500 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-cream shadow-md" data-id="element-280" data-mp="88gz9uzw6s6h">
                  {DISCOUNT_LABEL}
                </span>
                <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-petrol-100" data-id="element-281" data-mp="2a4y85t7bjqni">
                  Antes <span className="ml-1 font-serif text-lg normal-case tracking-normal text-petrol-100/80 line-through decoration-terra-300 decoration-2" data-id="element-282" data-mp="2f27v9278jq86">{ORIGINAL_PRICE}</span>
                </p>
                <p className="mt-1 text-[11px] font-bold uppercase tracking-[0.18em] text-gold-300" data-id="element-283" data-mp="2564u9zo4dxmt">Hoy</p>
                <p className="mt-1 font-serif text-[3.5rem] leading-none text-gold-300 sm:text-7xl" data-id="element-284" data-mp="1r6c4c6kf3lfw">{PRICE}</p>
                <p className="mt-2 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.12em] text-cream" data-id="element-285" data-mp="1w4x8ui6pcra5">
                  <ZapIcon className="h-3.5 w-3.5 text-gold-300" aria-hidden="true" data-id="element-286" data-mp="3lhil36kfezpq" /> Acceso digital inmediato
                </p>
              </div>

              <div className="mt-5" data-id="element-287" data-mp="3p2ak87e7t7t5">
                <CtaButton href={CHECKOUT_URL} className="w-full" data-id="element-288" data-mp="3oz68moyf79sg" />
              </div>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1.5" data-id="element-289" data-mp="3k0uz6fc1f1ar">
                {trust.map(({
                label,
                icon: Icon
              }) => <li key={label} className="flex items-center gap-1.5 text-xs text-ink/60" data-id="element-290" data-mp="3a48h1yb3iocf">
                    <Icon className="h-3.5 w-3.5 text-sage-700" aria-hidden="true" data-id="element-291" data-mp="bm37r8vk4cuf" />
                    {label}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}